import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useSelector } from 'react-redux';
import { getAuthUser } from '../store/slices/authSlice';
import { getTokenFromLocalStorage } from '../utils/helper';

const SocketAPI = () => {
  const [socket, setSocket] = useState(null);
  const authUser = useSelector(getAuthUser);
  // Prefer the redux-sourced token; fall back to localStorage (set by login).
  // On a page refresh redux-persist rehydrates asynchronously, so authUser can
  // be null on first mount — the localStorage fallback + the effect dep below
  // ensure we still connect (and reconnect) with a valid token.
  const token = authUser?.auth_token || getTokenFromLocalStorage();

  useEffect(() => {
    if (!token) return; // Don't connect until authenticated — avoids a dead,
    // unauthenticated socket that never recovers (empty-deps bug).

    const SOCKET_URL = process.env.REACT_APP_CHAT_SOCKET;
    const socketInstance = io(SOCKET_URL, {
      transports: ['websocket'],
      // Function form so every (re)connect reads the freshest access token from
      // localStorage — central EdDSA tokens are short-lived and rotate on 401,
      // so a reconnect must not reuse a stale closure token.
      auth: (cb) => {
        const latest = getTokenFromLocalStorage() || token;
        cb({ token: latest });
      },
    });
    setSocket(socketInstance);

    return () => {
      if (socketInstance) socketInstance.disconnect();
    };
  }, [token]);

  return socket;
};

export default SocketAPI;
